// extracted by mini-css-extract-plugin
export var caption = "captiontwofleximg-module--caption--e28d4";
export var captiontwofleximgwrapper = "captiontwofleximg-module--captiontwofleximgwrapper--607cf";
export var imagestyle = "captiontwofleximg-module--imagestyle--6260b";
export var twofleximgwrapper = "captiontwofleximg-module--twofleximgwrapper--7070f";
export var twofleximgwrapperp = "captiontwofleximg-module--twofleximgwrapperp--a443e";